import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import { useSelector } from 'react-redux';
import Carousel from '../../../component/carousel/Carousel';
import { WayBottomIcon, WayTopIcon } from '../../../component/icon/Icon';
import { ObjTest } from '../../../util/common';

import '../style/infoModal.less';



interface InfoModalProps {
    visible: boolean; // 显隐
    item: any; // 默认显示的项
    list: any[]; // 全量列表
    onFinish: () => void; // 确定或取消 
}


/**
 * 点击作品图片的弹窗
 */
const InfoModal = (props: InfoModalProps) => {
    const {visible, item, list, onFinish} = props;
    const { isMobile } = useSelector((state: any) => state.reducer);
    const [currentInex, setCurrentIndex] = useState(0);
    const [currentItem, setCurrentItem] = useState(null);


    useEffect(() => {
        if (item && ObjTest.isNotEmptyArray(list)) {
            // 生成默认下标
            const tempIndex = list.findIndex(v => v.pkid === item.pkid);
            if (tempIndex >=0) {
                setCurrentIndex(tempIndex);
                setCurrentItem(item);
            }
        }
    }, [item, list]);


    /**
     * 上一条，下一条切换
     * @param index 
     */
    const handleSwitch = (index: number) => {
        if (index >= 0 || index <= list.length - 1) {
            setCurrentIndex(index);
            const tempItem = list.find((v, vi) => index === vi);
            if (tempItem) {
                setCurrentItem(tempItem);
            }
        }
    };


    /**
     * 渲染PC布局内容
     */
    const contentPC = () => {
        return (
            <div className="product-info-modal-wrapper flexjs" style={{height: 740}}>
                <div className="detail-texts">
                    <div className="item-content">
                        <div className="f40 ftl mb56">{(currentItem || {}).projectName}</div>
                        <div className="f14 mb8">建设单位：{(currentItem || {}).constructionUnit}</div>
                        <div className="f14 mb8">项目规模：{(currentItem || {}).projectScale}</div>
                        <div className="f14 mb8">服务范围：{(currentItem || {}).serviceArea}</div>
                        <div className="f14 mb8">建设状态：{(currentItem || {}).constructionState}</div>
                        <div className="f14 lh24 mt24 mb48">{(currentItem || {}).introduction}</div>
                        <div className="f14" style={{color: '#666'}}>{(currentItem || {}).awards}</div>
                    </div>
                    <div className="item-switch flexic flexjs">
                        <span title="占位" />
                        <span className="mr16">
                            <Button 
                                type="link" 
                                disabled={currentInex === 0 ? true : false}
                                onClick={() => handleSwitch(currentInex - 1)}
                            >
                                <WayTopIcon className="f30" />
                            </Button>
                            <Button 
                                type="link" 
                                disabled={currentInex === list.length - 1 ? true : false}
                                onClick={() => handleSwitch(currentInex + 1)}
                            >
                                <WayBottomIcon className="f30" />
                            </Button>
                        </span>
                    </div>
                </div>
                <div className="detail-images">
                    <Carousel data={(currentItem || {}).images || []} />
                </div>
            </div>
        );
    };


    /**
     * 渲染Mobile布局内容
     */
    const contentMobile = () => {
        return (
            <div className="w" style={{background: '#202020'}}>
                <Carousel data={(currentItem || {}).images || []} />
                <div className="plr16 pt24 pb12" style={{color: '#fff'}}>
                    <div className="f32 ftl mb24 eps">{(currentItem || {}).projectName}</div>
                    <div className="f14 mb8">建设单位：{(currentItem || {}).constructionUnit}</div>
                    <div className="f14 mb8">项目规模：{(currentItem || {}).projectScale}</div>
                    <div className="f14 mb8">服务范围：{(currentItem || {}).serviceArea}</div>
                    <div className="f14">建设状态：{(currentItem || {}).constructionState}</div>
                    <div className="f14 ofa lh24 mtb12" style={{maxHeight: 96}}>{(currentItem || {}).introduction}</div>
                    <div className="f14" style={{color: '#666'}}>{(currentItem || {}).awards}</div>
                </div>
            </div>
        );
    };


    if (!currentItem) {
        return null;
    }


    return (
        <Modal 
            width={isMobile ? null : 1470}
            visible={visible}
            style={isMobile ? {top: 60} : null}
            onCancel={onFinish}
            maskClosable={false}
            onOk={onFinish}
        >
            {
                isMobile ? contentMobile() : contentPC()
            }
        </Modal>
    );
};

export { InfoModal };